// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-card {
  background: linear-gradient(45deg, #ff9800, #ff5722);
  color: white;
}

.etiquetas {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}

ion-badge {
  --background: rgba(255, 255, 255, 0.2);
}

.mensaje-leido {
  background: linear-gradient(45deg, #f0f0f0, #ffffff);
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/app/components/mensaje/mensaje.component.scss"],"names":[],"mappings":"AAAA;EACI,oDAAA;EACA,YAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;AACJ;;AAEA;EACI,sCAAA;AACJ;;AAEA;EACI,oDAAA;EACA,YAAA;AACJ","sourcesContent":[".custom-card {\r\n    background: linear-gradient(45deg, #ff9800, #ff5722);\r\n    color: white;\r\n}\r\n\r\n.etiquetas {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-top: 15px;\r\n}\r\n\r\nion-badge {\r\n    --background: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.mensaje-leido {\r\n    background: linear-gradient(45deg, #f0f0f0, #ffffff);\r\n    color: black;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
